















































































































































































import Modal from '@/project/modals/Modal.vue';
import { Component } from 'vue-property-decorator';
import { MenuItem } from '@/types/apiServerContract';
import Accordion from '@/core/ui-components/Accordion.vue';
import authService from '@/core/auth/auth.service';
import megaMenuService from '@/project/shared/megaMenu.service';
import NavigationStore, { ClientMenuItem } from '@/project/layout/navigation/navigation.store';
import serverContextService from '@/core/serverContext.service';
import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';
import { PageName } from '@/router/routes/constants';
import CampaignIcon from '@/project/product/campaigns/CampaignIcon.vue';

@Component({
    components: {
        Accordion,
        CampaignIcon
    }
})
export default class MobileMenu extends Modal {
    private navigation: readonly (MenuItem | ClientMenuItem)[] = [];
    private breadcrumb: (MenuItem | ClientMenuItem)[] = [];
    private activeLevel: number = 0;
    private forward = true;
    get favouritesPageName() {
        return PageName.MY_ACCOUNT_FAVOURITES;
    }

    get clientNavigationItems() {
        return [NavigationStore.clientNavigationItems];
    }

    async created() {
        this.navigation = await megaMenuService.getMegaMenu();
        this.navigateToActiveNavigationItemOnDemand();
    }

    private navigateToActiveNavigationItemOnDemand(): void {
        const navigationItems = [...this.clientNavigationItems, ...this.navigation];

        for (let i = 0; i < navigationItems.length; i++) {
            const navigationItem = navigationItems[i];

            if (navigationItem) {
                const activeItemTree = this.buildActiveItemTreeFor(navigationItem);

                if (activeItemTree && activeItemTree.length) {
                    for (let a = 0; a < activeItemTree.length; a++) {
                        this.nextLevel(activeItemTree[a]);
                    }

                    return;
                }
            }
        }
    }

    private buildActiveItemTreeFor(menuItem: ClientMenuItem | MenuItem, tree: (ClientMenuItem | MenuItem)[] = []): (ClientMenuItem | MenuItem)[] | null {
        const isClientMenuItem = Object.prototype.hasOwnProperty.call(menuItem, 'page');
        const menuItemProperty = isClientMenuItem ? 'page' : 'url';
        const currentPage = this.$route[isClientMenuItem ? 'name' : 'path'];

        if (Object.prototype.hasOwnProperty.call(menuItem, menuItemProperty) && menuItem[menuItemProperty] === currentPage) {
            return [...tree, menuItem];
        }

        if (menuItem.children && menuItem.children.length) {
            for (const menu of menuItem.children) {
                const childTree = this.buildActiveItemTreeFor(menu, [...tree, menuItem]);
                if (childTree) {
                    const activeChild = childTree[childTree.length - 1];

                    if (activeChild) {
                        // Logic for this is reflected in template (see this.menuItemsChildrenHaveChildren)
                        return activeChild.children && activeChild.children.length ? childTree : childTree.slice(0, childTree.length - 1);
                    }
                }
            }
        }

        return null;
    }

    private get isLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    private get campaignCode() {
        return this.campaignLink?.url.split('/').pop();
    }

    private get campaignLink() {
        return serverContextService.settings.menuCampaignLink;
    }

    private get activeParent(): MenuItem | ClientMenuItem | null {
        if (!this.breadcrumb.length) return null;
        return this.breadcrumb[this.activeLevel - 1];
    }

    private nextLevel(MenuItem: MenuItem | ClientMenuItem) {
        this.activeLevel++;
        this.breadcrumb.push(MenuItem);
        this.forward = true;
    }

    private previousLevel() {
        this.activeLevel--;
        this.breadcrumb.pop();
        this.forward = false;
    }

    private menuItemsChildrenHaveChildren(menuItem: MenuItem) {
        return menuItem.children?.some(x => x.children.length > 0);
    }

    private get children() {
        return this.activeParent?.children ?? [];
    }

    private get enterAnimationClasses() {
        const animCls = this.forward ? 'slideInRight' : 'slideInLeft';
        return `animated ${animCls} u-anim-dur-400 u-anim-ease-in-out`;
    }

    private get leaveAnimationClasses() {
        const animCls = this.forward ? 'slideOutLeft' : 'slideOutRight';
        return `animated ${animCls} u-anim-dur-400 u-anim-ease-in-out`;
    }

    private openLogin() {
        loginFormOverlayService.show('login');
    }

    private showNavElement(item: ClientMenuItem) {
        return NavigationStore.showNavElement(item);
    }

    private get productGuidePage() {
        return serverContextService?.settings?.productGuidePage;
    }

    private get salesAndSupportPage() {
        return serverContextService?.settings?.salesAndSupportPage;
    }
}
